const createScenario = {
  title: 'Crie um cenário',

  form: {
    header: {
      title: 'Olá {{firstName}},',
    },
    fields: {
      sitePlaceHolder: 'Qual é o nome da sua operação?',
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      details: {
        header: 'Qual dos cenários você gostaria de executar com o Moovex?',
        instructions: 'Por favor, verifique o campo que mais descreva a sua zona de trabalho.',
      },
    },

    button: 'PRECISO DETALHES',
  },
};

export default createScenario;
